import { extractData, getShowroomAll } from "api"
import { trackBuildMazdaPopUp, trackPopUpOpen } from "common/analytics"
import NextLink from "common/bit/NextLink"
import {
  isModelHasMeetingIframe,
  isModelHasTestDriveIframe,
} from "components/Schedule/getIframeLink"
import { resolveCmsActionLink } from "components/Schedule/resolveCmsActionLink"
import { STEPS_EN } from "components/shopFeatures/wizard/constants"
import { useEffect, useState } from "react"
import ClassicPopUp from "reusable/popups/ClassicPopUp"
import { useTypedSelector } from "store"
import styled from "styled-components"
import colors from "theme/colors"
import { TypographyCenter } from "theme/shared"
import TestDrivePopup from "../testDrive/TestDrivePopupWrapper"
import PurchaseToolsRow from "./PurchaseToolsRow"

const StyledWrapper = styled.div`
  text-align: center;
  overflow: auto;
  width: 100%;
`
const StyledButton = styled.div<{ $dark?: boolean }>`
  margin-top: 10px;
  background-color: ${(p) =>
    p.$dark ? p.theme.colors.black : p.theme.colors.white};
  border-radius: 3px;
  height: 45px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
`
const StyledNextLink = styled(NextLink)`
  width: 100%;
  max-width: 300px;
  align-self: center;
`

const StyledTestDrivePopup = styled(TestDrivePopup)`
  label {
    padding-top: 30px;
  }
`

type PopupProps = {
  openTestDrivePopup: (openForm: boolean) => void
  onClose: () => void
  open: boolean
  setPopupOpen?: (falsy: boolean) => void
  shopUrl: string
  numberOfFinishingLevels: number
  modelId?: number
  isDriveTestAvailable?: boolean
  showroomMeetingUrl?: string
  driveTestUrl?: string
}

const PurchaseToolsPopup = ({
  onClose,
  open,
  openTestDrivePopup,
  shopUrl,
  modelId,
  isDriveTestAvailable,
  showroomMeetingUrl,
  driveTestUrl,
}: PopupProps) => {
  const [leadFormPopupOpen, setLeadFormPopupOpen] = useState(false)
  const [showRoomList, setShowRoomList] = useState([])

  const { auth } = useTypedSelector((state) => state)

  useEffect(() => {
    const fetchData = async () => {
      const data = await getShowroomAll(
        null as unknown as number,
        null as unknown as number
      ).then(extractData)
      setShowRoomList(data?.body)
    }
    fetchData().catch((error) => console.log(error))
  }, [])

  const { userInfo } = auth

  // A CMS link, when set, overrides the default destination for its button.
  // Null means the field was empty, so the existing behavior is preserved.
  const cmsShowroomLink = resolveCmsActionLink(showroomMeetingUrl)
  const cmsDriveTestLink = resolveCmsActionLink(driveTestUrl)

  return (
    <>
      <ClassicPopUp open={open} onClose={onClose} title={"נשמח לעזור לך לבחור"}>
        <StyledWrapper>
          <StyledTestDrivePopup
            open={leadFormPopupOpen}
            onClose={() => {
              setLeadFormPopupOpen(false)
            }}
            showRoomsList={showRoomList}
            dialogClass="summaryTestDrive"
            title="פגישה באולם תצוגה"
            modelId={modelId}
            userInfo={userInfo}
            buttonText="תאמו איתי פגישה"
            analyticName="showrooms meeting"
            isshop
          />
          {cmsShowroomLink || isModelHasMeetingIframe(modelId) ? (
            <NextLink href={cmsShowroomLink ?? `/meeting/${modelId}`}>
              <PurchaseToolsRow
                text="לתיאום פגישה באולם תצוגה"
                iconName="fi_calendar"
                page={STEPS_EN.summary}
                onClick={() => {
                  trackPopUpOpen("showrooms meeting")
                }}
              />
            </NextLink>
          ) : (
            <PurchaseToolsRow
              text="לתיאום פגישה באולם תצוגה"
              iconName="fi_calendar"
              page={STEPS_EN.summary}
              onClick={() => {
                setLeadFormPopupOpen(true)
                trackPopUpOpen("showrooms meeting")
              }}
            />
          )}
          {/* Hide the test-drive CTA only when the CMS field IsDriveTestAvailable
              is explicitly false. Show it when true or undefined (backward-compat). */}
          {isDriveTestAvailable !== false &&
            (cmsDriveTestLink || isModelHasTestDriveIframe(modelId) ? (
              <NextLink href={cmsDriveTestLink ?? `/test-drive/${modelId}`}>
                <PurchaseToolsRow
                  text="להזמנת נסיעת הדגמה"
                  iconName="location-pin"
                  onClick={() => openTestDrivePopup(false)}
                />
              </NextLink>
            ) : (
              <PurchaseToolsRow
                text="להזמנת נסיעת הדגמה"
                iconName="location-pin"
                onClick={() => openTestDrivePopup(true)}
              />
            ))}
          <NextLink href="/contact-us">
            <PurchaseToolsRow text="יצירת קשר" iconName="fi_send" />
          </NextLink>
        </StyledWrapper>
        <StyledNextLink href={shopUrl}>
          <StyledButton $dark onClick={trackBuildMazdaPopUp}>
            <TypographyCenter $color={colors.white}>
              רכישה Online
            </TypographyCenter>
          </StyledButton>
        </StyledNextLink>
      </ClassicPopUp>
    </>
  )
}

export default PurchaseToolsPopup
